<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('navigation.help')"
    >
      <b-row>
        <b-col md="12">
          <ok-table
            ref="datatable"
            :config="config"
          >
            <template
              slot="actions-column"
              slot-scope="{ props }"
            >
              <b-button
                size="sm"
                @click="goToSection(props.row)"
              >
                {{ $t('forms.edit') }}
              </b-button>
            </template>
          </ok-table>
        </b-col>
      </b-row>
    </empty-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import SectionsTableConfig from './config/sections-table-config'

export default {
  components: {
    EmptyCard,
    BRow,
    BCol,
    BButton,
    OkTable: () => import(/* webpackChunkName: "ok-table" */ '@/@bya3/components/tables/ok-table/OkTable'),
  },
  data() {
    return {
      config: SectionsTableConfig,
    }
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    getStatusText(status) {
      switch (status) {
        case 1: return this.$t('payment.approved')
        case 2: return this.$t('payment.declined')
        default: return this.$t('payment.pending')
      }
    },
    goToSection(row) {
      this.$router.push({ name: 'super:help-section', params: { id: row.id } })
    },
  },
}
</script>
